import React, { ReactNode } from 'react';
import { IBackgroundCoverHeroFields } from '../../../../../types/contentful';
import cx from 'classnames';

import { getImageData } from 'src/utils/contentful';
import GlImage from '../../../Image';
import { BackgroundContainer } from './BackgroundContainer';
import FeatureTicker from 'src/components/FeatureTicker';

interface BackgroundCoverHeroProps extends IBackgroundCoverHeroFields {
  children?: ReactNode;
}

// Mark full-width
export function BackgroundCoverHero({
  backgroundImage,
  headingText,
  children,
  ticker
}: BackgroundCoverHeroProps) {
  const hasChildren = !!children;

  return (
    <div>
      <div
        data-blockid="background-cover-hero"
        data-testid="background-cover-hero"
        className={cx(
          'relative z-0 -mb-14 w-full overflow-hidden',
          hasChildren && 'mb-auto h-auto desktop:-mb-20'
        )}
      >
        <GlImage
          {...getImageData(backgroundImage)}
          loading="eager"
          layout="fill"
          objectFit="cover"
          width={undefined}
          height={undefined}
          priority
          className={hasChildren ? 'hidden! desktop:!block' : ''}
        />

        <BackgroundContainer withHeroChild={hasChildren}>
          <div
            className={cx(
              'm-0 box-border flex flex-wrap justify-start',
              hasChildren && 'p-0'
            )}
          >
            {children ? (
              children
            ) : (
              <div className="z-[2] w-full shrink-0 grow-0 basis-full desktop:basis-7/12">
                <h1
                  className="
                  z-[2]
                  mb-6
                  pb-[72px]
                  pt-[54px]
                  text-[58px]
                  leading-[50px]
                  text-white
                  tablet:pb-[100px]
                  tablet:pt-[100px]
                  tablet:text-[104px]
                  tablet:leading-[88px]
                  desktop:pb-[100px]
                  desktop:pt-[124px]
                  "
                  data-testid="background-cover-text"
                >
                  {headingText}
                </h1>
              </div>
            )}
          </div>
        </BackgroundContainer>
      </div>
      {ticker && <FeatureTicker {...ticker.fields} />}
    </div>
  );
}
